import { useEffect, useState } from "react";
import { Images } from "lucide-react";
import api from "@/lib/api";
import { Loader } from "@/components/common/Loader";
import { PageHeader, EmptyState } from "@/components/dashboard/ui";
import { PhotoMasonry } from "@/components/gallery/PhotoMasonry";
import { Lightbox } from "@/components/gallery/Lightbox";

export default function PhotosPage() {
  const [events, setEvents] = useState(null);
  const [active, setActive] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [idx, setIdx] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/events").then((r) => {
      setEvents(r.data.events);
      if (r.data.events[0]) setActive(r.data.events[0]);
    }).catch(() => setEvents([]));
  }, []);

  useEffect(() => {
    if (!active) return;
    setLoading(true);
    api.get(`/events/${active.id}/photos`).then((r) => setPhotos(r.data.photos)).finally(() => setLoading(false));
  }, [active]);

  if (!events) return <Loader />;
  if (events.length === 0) return <><PageHeader title="Photos" /><EmptyState icon={Images} title="No photos yet" desc="Create an event and upload photos to see them here." /></>;

  return (
    <div>
      <PageHeader title="Photos" subtitle="Every photo across your events, organised by gallery." />
      <div className="flex gap-2 flex-wrap mb-6">
        {events.map((e) => (
          <button key={e.id} data-testid={`photos-event-${e.id}`} onClick={() => setActive(e)}
            className={`text-sm rounded-full px-4 py-2 transition-colors ${active?.id === e.id ? "bg-gold text-black" : "glass text-white hover:border-gold/40"}`}>
            {e.name} <span className="opacity-60">({e.photo_count})</span>
          </button>
        ))}
      </div>
      {loading ? <Loader /> : (
        <PhotoMasonry photos={photos} watermark={active?.watermark} onOpen={setIdx} />
      )}
      <Lightbox photos={photos} index={idx} onClose={() => setIdx(null)} setIndex={setIdx} downloadable watermark={active?.watermark} />
    </div>
  );
}
